import React from 'react'

import styled from 'styled-components/native'

import { BodyText, Size } from '../../atoms/bodyText/BodyText'
import { BodyTextSize, TextAlign } from '../../styles/typeStyles'
import { tID } from '../../utils/utils'

export interface InlineBannerProps {
  text: React.ReactNode | string
  backgroundColor: string
  textColor?: string
  testId?: string
  icon?: React.ReactNode
  iconMarginRight?: number
  trailingLink?: React.ReactElement
  marginBottom?: string
  marginTop?: string
  marginLeft?: string
  marginRight?: string
  textSize?: BodyTextSize
  borderRadius?: string
  padding?: string
  textAlign?: TextAlign
  title?: React.ReactNode | string
  centerContent?: boolean
  useInnerContainer?: boolean
}
const Container = styled.View<{
  backgroundColor: string
  marginBottom?: string
  marginTop?: string
  marginLeft?: string
  marginRight?: string
  borderRadius?: string
  padding?: string
  centerContent?: boolean
}>(({ backgroundColor, marginBottom, marginTop, marginLeft, marginRight, borderRadius, padding, centerContent }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: centerContent ? 'center' : 'flex-start',
  marginBottom: marginBottom || '24px',
  marginTop,
  borderRadius: borderRadius || '16px',
  backgroundColor: backgroundColor,
  padding: padding || '12px',
  marginLeft,
  marginRight,
}))

const IconContainer = styled.View<{ marginRight: number }>(({ marginRight }) => ({
  alignSelf: 'flex-start',
  width: 24,
  height: 24,
  justifyContent: 'center',
  alignItems: 'center',
  marginRight,
}))

const TextContainer = styled.View({
  flex: 1,
})

const InnerContainer = styled.View({
  display: 'flex',
  flexDirection: 'row',
  maxWidth: '100%',
})

export const InlineBanner: React.FC<InlineBannerProps> = ({
  text,
  testId,
  backgroundColor,
  textColor,
  trailingLink,
  icon,
  iconMarginRight = 4,
  marginBottom,
  marginTop,
  marginLeft,
  marginRight,
  textSize = Size.DEFAULT,
  borderRadius,
  padding,
  textAlign,
  title,
  centerContent = false,
  useInnerContainer = false,
}) => {
  const content = (
    <>
      {icon && <IconContainer marginRight={iconMarginRight}>{icon}</IconContainer>}
      <TextContainer>
        {title && (
          <BodyText
            size={textSize}
            text={title}
            color={textColor}
            bold
            style={text ? { marginBottom: 4 } : undefined}
          />
        )}
        <BodyText size={textSize} color={textColor} wrap text={text} textAlign={textAlign}>
          {trailingLink && <>&nbsp;{trailingLink}</>}
        </BodyText>
      </TextContainer>
    </>
  )

  return (
    <Container
      backgroundColor={backgroundColor}
      marginBottom={marginBottom}
      marginTop={marginTop}
      marginLeft={marginLeft}
      marginRight={marginRight}
      testID={tID(testId)}
      borderRadius={borderRadius}
      padding={padding}
      centerContent={centerContent}
    >
      {useInnerContainer ? <InnerContainer>{content}</InnerContainer> : content}
    </Container>
  )
}
